import React, { Suspense } from 'react'

import { type ColumnConfig } from '@ant-design/plots'
import { Spin } from 'antd'
import { useUnit } from 'effector-react'

import { COMMON_CHARTS_CONFIG } from '../../lib/constants'
import { $logins } from '../../model/statistics-app-data.model'
import { StatisticsSectionWrapper } from '../StatisticsSectionWrapper'

const Column = React.lazy(
  () => import('@ant-design/plots/es/components/column'),
)

export const LoginsChart = () => {
  const data = useUnit($logins)
  const total = data.reduce((acc, item) => acc + item.data, 0)
  const config: ColumnConfig = {
    data,
    padding: -15,
    axis: {
      x: false,
      y: {
        title: false,
        label: false,
        tick: false,
        grid: true,
        gridStroke: 'rgba(0,0,0,0.8)',
        gridOpacity: 1,
        gridLineDash: [0, 0],
        gridLineWidth: 0.5,
      },
    },
    colorField: 'data',
    scale: {
      color: {
        range: ['#9C73E5'],
      },
    },
    style: {
      radiusTopLeft: 2,
      radiusTopRight: 2,
      radiusBottomLeft: 2,
      radiusBottomRight: 2,
    },
    ...COMMON_CHARTS_CONFIG,
  }

  const middle = <span>{total}</span>

  const bottom = (
    <Suspense fallback={<Spin />}>
      <Column {...config} />
    </Suspense>
  )

  return (
    <StatisticsSectionWrapper
      title="Входы авторизованных пользователей"
      middle={middle}
      bottom={bottom}
    />
  )
}
